var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { get } from 'lodash';
import { classNames, firstImageEntityProperty, formatDateString } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { CellHeader } from '../elements/cell-header';
import { PLATFORM_DATE_FORMAT } from '../constants';
import { ContentTitle } from '../elements/content-title';
import { IconTextValue } from '../elements/icon-text-value';
import { LinkButton } from '../elements/link-button';
import { ResponsiveContainer } from '../elements/responsive-container';
import { EntityThumbnailImage } from './entity-image';
import { useEntity } from '../hooks/use-entity';
import { useLang } from '../hooks/use-lang';
import { useMonthNames } from '../hooks/use-month-names';
import { SiteIcon, LocationIcon, ExternalLinkIconGlyph, PersonIcon, UnitIcon } from '@shapeable/icons';
var cls = classNames('feed-entry-detail-header');
export var FeedEntryDetailsHeaderDefaultProps = {
  color: '#FFFFFF',
  imageAspectRatio: {
    base: 18 / 9,
    tablet: 18 / 9,
    desktop: 16 / 11
  },
  colors: {
    text: 'strong',
    stroke: 'strong',
    border: 'strong',
    fill: 'strong',
    hover: {
      text: 'button-hover',
      border: 'button-hover',
      stroke: 'button-hover',
      fill: 'button-hover'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: ", " 0;\n    ", ";\n\n\n  "], ["\n    margin: ", " 0;\n    ", ";\n\n\n  "])), theme.UNIT(10), theme.APPLY_COLORS)
});
var LayoutStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: ", ";\n    align-items: center;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: ", ";\n    align-items: center;\n  "])), theme.UNIT(8)),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var BannerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    flex-shrink: 0;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    flex-shrink: 0;\n    width: 100%;\n  "])), theme.UNIT(3)),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 50%;\n  "], ["\n    width: 50%;\n  "])))
});
var TitlesStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: 1.3em;\n    line-height: 1.1;\n    margin: 0;\n  "], ["\n    font-size: 1.3em;\n    line-height: 1.1;\n    margin: 0;\n  "])))
});
var PreTitleStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    .shp--cell-header__label-and-badge {\n      align-items: baseline;\n    }\n    color: ", ";\n  "], ["\n    padding-bottom: ", ";\n    .shp--cell-header__label-and-badge {\n      align-items: baseline;\n    }\n    color: ", ";\n  "])), theme.UNIT(2), theme.COLOR('strong'))
});
var TitleStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n    h1 {\n      font-size: 1.5em;\n      margin: 0;\n    }\n  "], ["\n    \n    h1 {\n      font-size: 1.5em;\n      margin: 0;\n    }\n  "])))
});
var MainAuthorStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var InfoStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    gap: ", ";\n    padding-top: ", ";\n    ", "\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    gap: ", ";\n    padding-top: ", ";\n    ", "\n  "])), theme.UNIT(5), theme.UNIT(5), theme.H_DOT_BG()),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n  "], ["\n    flex-wrap: nowrap;\n  "])))
});
var PublishedStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LocationStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var WebsiteStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ResponsiveContainerStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ExternalLinkButtonStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    max-width: 300px;\n  "], ["\n    max-width: 300px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  ImageContainer: styled(ResponsiveContainer)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ResponsiveContainerStyles),
  Banner: styled(EntityThumbnailImage)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  Body: styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Titles: styled.div.attrs(cls.attr('titles'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  PreTitle: styled(CellHeader)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), PreTitleStyles),
  Title: styled(ContentTitle)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  MainAuthor: styled(IconTextValue)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), MainAuthorStyles),
  Info: styled.div.attrs(cls.attr('info'))(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Published: styled(IconTextValue)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), PublishedStyles),
  Location: styled(IconTextValue)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), LocationStyles),
  Website: styled(IconTextValue)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), WebsiteStyles),
  ExternalLinkButton: styled(LinkButton)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), ExternalLinkButtonStyles)
};
export var FeedEntryDetailsHeader = function (props) {
  var _a, _b, _c;
  var className = props.className,
    children = props.children,
    imageAspectRatio = props.imageAspectRatio,
    color = props.color,
    badgeColor = props.badgeColor,
    colors = props.colors;
  var entity = useEntity(props.entity);
  var image = firstImageEntityProperty(entity, ['banner', 'logo', 'photo']);
  var t = useLang();
  var monthNames = useMonthNames();
  var name = entity.name,
    openGraph = entity.openGraph,
    websiteName = entity.websiteName,
    websiteUrl = entity.websiteUrl,
    author = entity.author,
    published = entity.published,
    url = entity.url,
    _d = entity.locations,
    locations = _d === void 0 ? [] : _d,
    _e = entity.types,
    types = _e === void 0 ? [] : _e,
    _f = entity.people,
    people = _f === void 0 ? [] : _f;
  var hasTypes = !!types.length;
  var feedEntryType = (_a = types[0]) === null || _a === void 0 ? void 0 : _a.name;
  var hasLocations = !!locations.length;
  var hasAuthor = !!author;
  var hasWebsite = !!websiteUrl || !!websiteName;
  if (!image && entity.openGraph && entity.openGraph.image) {
    image = {
      id: "entity-image-".concat(entity.id),
      image: entity.openGraph.image
    };
  }
  if (!image && get(entity, 'image')) {
    image = {
      id: "entity-image-".concat(entity.id),
      image: get(entity, 'image')
    };
  }
  if (!image && get(entity, 'thumbnail')) {
    image = {
      id: "entity-image-".concat(entity.id),
      image: get(entity, 'thumbnail')
    };
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Layout, null, React.createElement(My.Banner, {
    entity: image,
    aspectRatio: imageAspectRatio
  }), React.createElement(My.Body, null, React.createElement(My.Titles, null, React.createElement(My.PreTitle, {
    badge: hasTypes && feedEntryType,
    colors: {
      background: badgeColor
    },
    _color: color
  }, t('Article')), React.createElement(My.Title, {
    colors: colors
  }, entity.name)), hasAuthor && React.createElement(My.MainAuthor, {
    iconSize: 48,
    color: color,
    iconComponent: PersonIcon,
    label: 'Author'
  }, author), React.createElement(My.Info, null, published && React.createElement(My.Published, {
    label: 'Published',
    color: color,
    iconComponent: UnitIcon,
    iconSize: 40
  }, formatDateString(published, t('Do MMM YYYY'), PLATFORM_DATE_FORMAT, {
    monthNames: monthNames
  })), hasLocations && React.createElement(My.Location, {
    label: 'City',
    color: color,
    href: (_b = locations[0]) === null || _b === void 0 ? void 0 : _b.path,
    iconComponent: LocationIcon,
    iconSize: 40
  }, (_c = locations[0]) === null || _c === void 0 ? void 0 : _c.name), hasWebsite && React.createElement(My.Website, {
    label: 'Website',
    color: color,
    href: websiteUrl,
    iconComponent: SiteIcon,
    iconSize: 40
  }, websiteName)), React.createElement(My.ExternalLinkButton, {
    href: url,
    colors: colors,
    icon: ExternalLinkIconGlyph,
    shape: 'rounded'
  }, t('Read Full Article')))), children);
};
FeedEntryDetailsHeader.defaultProps = FeedEntryDetailsHeaderDefaultProps;
FeedEntryDetailsHeader.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31;